// React component imports
import React, { useState, useEffect, useContext } from "react";
import styled from "styled-components";
import FormModal from "../../components/Modal/FormModal";
import { AddUserMemberForm } from "../../components/Form/Form";
import { AuthContext } from "../../context/authContext";
import api from '../../Api';
import { Link } from "react-router-dom";

import { LoadingOverlay, LoadingSpinner } from "../../globalStyles.js";

export const MyProfileC = () => {
  const { currentUser, loading, logout } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [formData, setFormData] = useState(null);
  const [errors, setErrors] = useState({});
  const [loadingCircle, setLoadingCircle] = useState(false);
  const [updateData, setUpdateData] = useState(false);

  useEffect(() => {
    const initializeForm = () => {
      setFormData({
        firstname: "",
        lastname: "",
        dob: "",
        gender: ""
      });
    };
    initializeForm();
  }, [updateData]);

  const handleClose = () => {
    setModalOpen(false);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await api.get(
          `/classBooking/api/user/getUserMembers`, {
          withCredentials: true,
        }
        );
        setData(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, [updateData]);

  const handleSubmit = async () => {
    setLoadingCircle(true);
    try {
      const res = await api.post(
        `/classBooking/api/user/addUserMember`,
        formData, { withCredentials: true, }
      );

      if (res.status === 200) {
        setModalOpen(false);
        setLoadingCircle(false);
        setUpdateData(!updateData);
      }
    } catch (err) {
      console.log(err);
      setLoadingCircle(false);
    }
  };

  const getInitial = (name) => {
    return name ? name.charAt(0).toUpperCase() : '';
  };

  // Not logged in state
  if (!currentUser) {
    return (
      <PageContainer>
        <PageHeader>
          <PageTitle>我的帳戶</PageTitle>
        </PageHeader>
        <NotLoggedInContainer>
          <NotLoggedInCard>
            <NotLoggedInIcon>👤</NotLoggedInIcon>
            <NotLoggedInTitle>您的帳戶</NotLoggedInTitle>
            <NotLoggedInText>
              登入以管理您的個人資料、添加家庭成員並保持資料更新。
            </NotLoggedInText>
            <NotLoggedInFeatures>
              <FeatureItem>
                <FeatureIcon>✓</FeatureIcon>
                <FeatureText>管理您的帳戶</FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>✓</FeatureIcon>
                <FeatureText>添加孩子/家庭成員</FeatureText>
              </FeatureItem>
              <FeatureItem>
                <FeatureIcon>✓</FeatureIcon>
                <FeatureText>使用已保存資料快速預訂</FeatureText>
              </FeatureItem>
            </NotLoggedInFeatures>
            <NotLoggedInButtons>
              <Link to="/c/loginC" style={{ width: '100%', textDecoration: 'none' }}>
                <PrimaryButton>登入</PrimaryButton>
              </Link>
              <Link to="/c/signupC" style={{ width: '100%', textDecoration: 'none' }}>
                <SecondaryButton>建立帳戶</SecondaryButton>
              </Link>
            </NotLoggedInButtons>
          </NotLoggedInCard>
        </NotLoggedInContainer>
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      {/* Header */}
      <PageHeader>
        <PageTitle>我的帳戶</PageTitle>
      </PageHeader>

      {/* Profile Card */}
      <ProfileCard>
        <ProfileAvatarWrapper>
          <ProfileAvatar>
            {getInitial(currentUser.name)}
          </ProfileAvatar>
          <OnlineIndicator />
        </ProfileAvatarWrapper>
        <ProfileInfo>
          <ProfileName>{currentUser.name}</ProfileName>
          <ProfileMobile>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
              <path d="M22 16.92V19.92C22.0011 20.1985 21.9441 20.4742 21.8325 20.7294C21.7209 20.9845 21.5573 21.2136 21.3521 21.4019C21.1469 21.5901 20.9046 21.7335 20.6408 21.8227C20.3769 21.9119 20.0974 21.9451 19.82 21.92C16.7428 21.5856 13.787 20.5341 11.19 18.85C8.77383 17.3147 6.72534 15.2662 5.19 12.85C3.49998 10.2412 2.44824 7.27099 2.12 4.18C2.09501 3.90347 2.12788 3.62476 2.2165 3.36162C2.30513 3.09849 2.44757 2.85669 2.63477 2.65162C2.82196 2.44655 3.04981 2.28271 3.30379 2.17052C3.55778 2.05833 3.83234 2.00026 4.11 2H7.11C7.59531 1.99522 8.06579 2.16708 8.43376 2.48353C8.80173 2.79999 9.04208 3.23945 9.11 3.72C9.23662 4.68007 9.47145 5.62273 9.81 6.53C9.94455 6.88792 9.97366 7.27691 9.89391 7.65088C9.81415 8.02485 9.62886 8.36811 9.36 8.64L8.09 9.91C9.51356 12.4135 11.5865 14.4864 14.09 15.91L15.36 14.64C15.6319 14.3711 15.9752 14.1858 16.3491 14.1061C16.7231 14.0263 17.1121 14.0555 17.47 14.19C18.3773 14.5286 19.3199 14.7634 20.28 14.89C20.7658 14.9585 21.2094 15.2032 21.5265 15.5775C21.8437 15.9518 22.0122 16.4296 22 16.92Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            {currentUser.mobile}
          </ProfileMobile>
          {currentUser.email && (
            <ProfileEmail>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                <path d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M22 6L12 13L2 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              {currentUser.email}
            </ProfileEmail>
          )}
        </ProfileInfo>
      </ProfileCard>

      {/* Members Section */}
      <SectionWrapper>
        <SectionHeader>
          <SectionTitle>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
              <path d="M17 21V19C17 16.7909 15.2091 15 13 15H5C2.79086 15 1 16.7909 1 19V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <circle cx="9" cy="7" r="4" stroke="currentColor" strokeWidth="2"/>
              <path d="M23 21V19C22.9986 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M16 3.13C16.8604 3.35031 17.623 3.85071 18.1676 4.55232C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89318 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            我的成員
          </SectionTitle>
          <MemberCount>{data.length} 位成員</MemberCount>
        </SectionHeader>

        {data.length === 0 ? (
          <EmptyMembersCard>
            <EmptyIcon>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
                <path d="M16 21V19C16 16.7909 14.2091 15 12 15H6C3.79086 15 2 16.7909 2 19V21" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                <circle cx="9" cy="7" r="4" stroke="#9ca3af" strokeWidth="1.5"/>
                <path d="M19 8V14M22 11H16" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </EmptyIcon>
            <EmptyText>尚未添加成員</EmptyText>
            <EmptySubtext>添加家庭成員以加快預訂速度</EmptySubtext>
          </EmptyMembersCard>
        ) : (
          <MembersList>
            {data.map((info, index) => {
              const dateOfBirth = new Date(info.dateofbirth);
              const formattedDateOfBirth = dateOfBirth.toLocaleDateString('zh-HK', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
              });

              return (
                <MemberCard key={info.id || index}>
                  <MemberAvatar>
                    {info.first_name?.charAt(0).toUpperCase() || '?'}
                  </MemberAvatar>
                  <MemberDetails>
                    <MemberName>{info.first_name} {info.last_name}</MemberName>
                    <MemberIdBadge>ST{info.id}</MemberIdBadge>
                    <MemberInfo>
                      <MemberInfoItem>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2"/>
                          <path d="M16 2V6M8 2V6M3 10H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        {formattedDateOfBirth}
                      </MemberInfoItem>
                      <MemberInfoItem>
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="2"/>
                          <path d="M5 20C5 17.2386 8.13401 15 12 15C15.866 15 19 17.2386 19 20" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                        </svg>
                        {info.gender || '未設定'}
                      </MemberInfoItem>
                    </MemberInfo>
                  </MemberDetails>
                </MemberCard>
              );
            })}
          </MembersList>
        )}
      </SectionWrapper>

      {/* Action Buttons */}
      <ActionButtonsWrapper>
        <AddMemberButton onClick={() => setModalOpen(true)}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
            <path d="M12 8V16M8 12H16" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
          </svg>
          添加成員
        </AddMemberButton>
        
        <LogoutButton onClick={logout}>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M16 17L21 12L16 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          登出
        </LogoutButton>
      </ActionButtonsWrapper>

      {/* Modal */}
      {modalOpen && (
        <FormModal
          title="添加成員"
          isOpen={modalOpen}
          autoClose={false}
          handleClose={handleClose}
        >
          {formData && (
            <AddUserMemberForm
              formData={formData}
              setFormData={setFormData}
              withSubmitBtn={true}
              language={"c"}
              errors={errors}
              handleSubmit={handleSubmit}
            />
          )}
        </FormModal>
      )}

      {/* Loading */}
      {loadingCircle && (
        <LoadingOverlay>
          <LoadingSpinner />
        </LoadingOverlay>
      )}
    </PageContainer>
  );
};

export default MyProfileC;

// ============================================
// STYLED COMPONENTS
// ============================================

const PageContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8ec 100%);
  padding-bottom: 40px;
`;

const PageHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.06);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const PageTitle = styled.h1`
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;
`;

// Profile Card
const ProfileCard = styled.div`
  margin: 16px;
  padding: 24px;
  background: white;
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
  display: flex;
  align-items: center;
  gap: 20px;
`;

const ProfileAvatarWrapper = styled.div`
  position: relative;
`;

const ProfileAvatar = styled.div`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  font-size: 32px;
  font-weight: 700;
  color: white;
  box-shadow: 0 4px 15px rgba(26, 115, 232, 0.3);
`;

const OnlineIndicator = styled.div`
  position: absolute;
  bottom: 4px;
  right: 4px;
  width: 16px;
  height: 16px;
  background: #10b981;
  border: 3px solid white;
  border-radius: 50%;
`;

const ProfileInfo = styled.div`
  flex: 1;
`;

const ProfileName = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 22px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 8px 0;
`;

const ProfileMobile = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 4px;
`;

const ProfileEmail = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #6b7280;
`;

// Section
const SectionWrapper = styled.div`
  margin: 0 16px 16px;
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
`;

const SectionTitle = styled.h3`
  display: flex;
  align-items: center;
  gap: 10px;
  font-family: 'Poppins', sans-serif;
  font-size: 17px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0;

  svg {
    color: #1a73e8;
  }
`;

const MemberCount = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: #6b7280;
  background: #f3f4f6;
  padding: 6px 12px;
  border-radius: 20px;
`;

// Members List
const MembersList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const MemberCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: flex-start;
  gap: 16px;
  transition: all 0.2s ease;

  &:hover {
    transform: translateX(4px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.08);
  }
`;

const MemberAvatar = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 14px;
  background: linear-gradient(135deg, #a855f7 0%, #7c3aed 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Poppins', sans-serif;
  font-size: 20px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
`;

const MemberDetails = styled.div`
  flex: 1;
  min-width: 0;
`;

const MemberName = styled.h4`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 6px 0;
`;

const MemberIdBadge = styled.span`
  display: inline-block;
  padding: 3px 8px;
  background: #f3f4f6;
  color: #6b7280;
  border-radius: 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 11px;
  font-weight: 600;
  margin-bottom: 10px;
`;

const MemberInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

const MemberInfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Poppins', sans-serif;
  font-size: 13px;
  color: #6b7280;

  svg {
    color: #9ca3af;
  }
`;

// Empty State
const EmptyMembersCard = styled.div`
  background: white;
  border-radius: 16px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
`;

const EmptyIcon = styled.div`
  margin-bottom: 16px;
`;

const EmptyText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 16px;
  font-weight: 600;
  color: #374151;
  margin: 0 0 8px 0;
`;

const EmptySubtext = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #9ca3af;
  margin: 0;
`;

// Action Buttons
const ActionButtonsWrapper = styled.div`
  margin: 24px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const AddMemberButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #1a73e8 0%, #0d5bba 100%);
  color: white;
  border: none;
  border-radius: 14px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 20px rgba(26, 115, 232, 0.35);
  }

  &:active {
    transform: translateY(0);
  }
`;

const LogoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  width: 100%;
  padding: 16px;
  background: white;
  color: #ef4444;
  border: 2px solid #fee2e2;
  border-radius: 14px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #fef2f2;
    border-color: #fecaca;
  }
`;

// Not Logged In Styles
const NotLoggedInContainer = styled.div`
  width: 100%;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
`;

const NotLoggedInCard = styled.div`
  width: 100%;
  max-width: 380px;
  background: white;
  border-radius: 24px;
  padding: 40px 28px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08);
  text-align: center;
`;

const NotLoggedInIcon = styled.div`
  font-size: 56px;
  margin-bottom: 16px;
`;

const NotLoggedInTitle = styled.h2`
  font-family: 'Poppins', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 12px 0;
`;

const NotLoggedInText = styled.p`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #666;
  line-height: 1.6;
  margin: 0 0 24px 0;
`;

const NotLoggedInFeatures = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 28px;
  text-align: left;
`;

const FeatureItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const FeatureIcon = styled.span`
  width: 24px;
  height: 24px;
  background: #e8f5e9;
  color: #34a853;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
`;

const FeatureText = styled.span`
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  color: #333;
`;

const NotLoggedInButtons = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const PrimaryButton = styled.button`
  width: 100%;
  padding: 14px;
  background: #1a1a1a;
  color: white;
  border: none;
  border-radius: 12px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #333;
    transform: translateY(-1px);
  }
`;

const SecondaryButton = styled.button`
  width: 100%;
  padding: 14px;
  background: transparent;
  color: #1a1a1a;
  border: 2px solid #e0e0e0;
  border-radius: 12px;
  font-family: 'Poppins', sans-serif;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #1a1a1a;
    background: #f5f5f5;
  }
`;
